import { render, staticRenderFns } from "./FormProductMeasureComponent.vue?vue&type=template&id=606cf705&scoped=true"
import script from "./FormProductMeasureComponent.vue?vue&type=script&lang=js"
export * from "./FormProductMeasureComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductMeasureComponent.vue?vue&type=style&index=0&id=606cf705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606cf705",
  null
  
)

export default component.exports